export default __webpack_public_path__ + "static/media/bg-4.e02c8a8b.png";